export default (investigator: User | undefined) => {
  let name = 'No investigator';
  if (investigator) {
    if (investigator.display_name) {
      name = `${investigator.display_name}`;
    }
    else {
      name = `${investigator?.first_name} ${investigator?.last_name}`;
    }
  }

  if (investigator && investigator.external_id) {
    name += ` (#${investigator?.external_id})`;
  }

  return name;
};
